import * as React from "react";
const DocShareSVG = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={56}
    height={56}
    fill="none"
    {...props}
  >
    <rect
      width={48}
      height={48}
      x={4}
      y={4}
      fill="#fff"
      fillOpacity={0.03}
      rx={24}
    />
    <rect
      width={48}
      height={48}
      x={4}
      y={4}
      stroke="#fff"
      strokeOpacity={0.06}
      strokeWidth={8}
      rx={24}
    />
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M36 33H20m0 0 4-4m-4 4 4 4m-4-14h16m0 0-4-4m4 4-4 4"
    />
  </svg>
);
export default DocShareSVG;
